var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEllipsis(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 27.25C8.7316 27.25 11.25 24.7316 11.25 21.625C11.25 18.5184 8.7316 16 5.625 16C2.5184 16 0 18.5184 0 21.625C0 24.7316 2.5184 27.25 5.625 27.25Z",
    fill: "#58585A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 27.25C25.6066 27.25 28.125 24.7316 28.125 21.625C28.125 18.5184 25.6066 16 22.5 16C19.3934 16 16.875 18.5184 16.875 21.625C16.875 24.7316 19.3934 27.25 22.5 27.25Z",
    fill: "#58585A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.375 27.25C42.4816 27.25 45 24.7316 45 21.625C45 18.5184 42.4816 16 39.375 16C36.2684 16 33.75 18.5184 33.75 21.625C33.75 24.7316 36.2684 27.25 39.375 27.25Z",
    fill: "#58585A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEllipsis);
export default __webpack_public_path__ + "static/media/ic-ellipsis.78f3e6c5246a3af4c1ace8bb2b3b41a4.svg";
export { ForwardRef as ReactComponent };